import { render } from "./FormGroupInput.vue?vue&type=template&id=63e410c8"
import script from "./FormGroupInput.vue?vue&type=script&lang=js"
export * from "./FormGroupInput.vue?vue&type=script&lang=js"
script.render = render

export default script